import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import RaiseALeadButton from './RaiseALeadButton';
import Tracker from './utils/trackers/QualifiedLeadSidebarCardTracker';
import QualifiedLeadFlags from './QualifiedLeadFlags';
import QualifiedLeadsList from './QualifiedLeadsList';
import QualifiedLeadUnsubmittableStatus from './QualifiedLeadUnsubmittableStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function QualifiedLeadsSidebarCardContent(props) {
  Tracker.applicationName = props.appName;
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  Tracker.leadContactVid = parseInt(props.contactVid, 10);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(QualifiedLeadUnsubmittableStatus, {
      contactVid: props.contactVid
    }), /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      direction: "row",
      justify: "center",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(RaiseALeadButton, {
        alertStore: props.alertStore,
        appName: props.appName,
        chatThreadId: props.chatThreadId,
        contactVid: props.contactVid
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsx(QualifiedLeadsList, {
        contactVid: props.contactVid
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: ["Powered by ", /*#__PURE__*/_jsx("b", {
          children: "Revenue"
        })]
      })
    })]
  });
}
function QualifiedLeadsSidebarCardTitle(props) {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "wrap",
    children: ["Qualified Leads", /*#__PURE__*/_jsx(QualifiedLeadFlags, {
      contactVid: props.contactVid
    })]
  });
}
QualifiedLeadsSidebarCardContent.propTypes = {
  alertStore: PropTypes.object.isRequired,
  appName: PropTypes.string.isRequired,
  chatThreadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
QualifiedLeadsSidebarCardContent.defaultProps = {
  chatThreadId: 0,
  contactVid: 0
};
QualifiedLeadsSidebarCardTitle.propTypes = {
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
QualifiedLeadsSidebarCardTitle.defaultProps = {
  contactVid: 0
};
export { QualifiedLeadsSidebarCardContent, QualifiedLeadsSidebarCardTitle };